import { c as _c } from "react/compiler-runtime";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import type { ApiProfileMin } from "@/generated/models/ApiProfileMin";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { DROP_BATCH_STALE_TIME_MS, fetchDropsByIds, orderDropsByIds, seedDropCache } from "@/services/api/drop-api";
interface UseUserWinningArtworksProps {
  readonly user: ApiProfileMin;
  readonly enabled?: boolean | undefined;
}
export const useUserWinningArtworks = t0 => {
  const $ = _c(18);
  const {
    user,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  const queryClient = useQueryClient();
  const winnerDropIds = user.winner_main_stage_drop_ids;
  let t2;
  if ($[0] !== winnerDropIds) {
    t2 = winnerDropIds.join(",");
    $[0] = winnerDropIds;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const winnerDropIdsKey = t2;
  let t3;
  if ($[2] !== winnerDropIdsKey) {
    t3 = [QueryKey.DROP, {
      ids: winnerDropIdsKey,
      scope: "user-winning-artworks"
    }];
    $[2] = winnerDropIdsKey;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== queryClient || $[5] !== winnerDropIds) {
    t4 = async () => {
      const drops = await fetchDropsByIds(winnerDropIds);
      seedDropCache(queryClient, drops);
      return orderDropsByIds(winnerDropIds, drops);
    };
    $[4] = queryClient;
    $[5] = winnerDropIds;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = enabled && winnerDropIds.length > 0;
  let t6;
  if ($[7] !== t3 || $[8] !== t4 || $[9] !== t5) {
    t6 = {
      queryKey: t3,
      queryFn: t4,
      enabled: t5,
      staleTime: DROP_BATCH_STALE_TIME_MS
    };
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const {
    data,
    isLoading,
    isError
  } = useQuery(t6);
  let t7;
  if ($[11] !== data) {
    t7 = data ?? [];
    $[11] = data;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const winningDrops = t7;
  let t8;
  if ($[13] !== isError || $[14] !== isLoading || $[15] !== winnerDropIds || $[16] !== winningDrops) {
    t8 = {
      winningDrops,
      isLoading,
      isError,
      winnerDropIds
    };
    $[13] = isError;
    $[14] = isLoading;
    $[15] = winnerDropIds;
    $[16] = winningDrops;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};